import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import BannerMetadata from '../BannerMetadata/BannerMetadata';

const RENDERING_STRATEGIES = {
  iframe: {
    displayedName: 'Iframe'
  },
  ps: {
    displayedName: 'Postscribe'
  },
  div: {
    displayedName: 'Div'
  }
};

export const AdmField = props => {
  const forceRenderMarkupRegex = /<div hidden data-str-render-strategy="(\w*)"><\/div>\n/;

  const [forcedRenderStrategy, setForcedRenderStrategy] = useState(
    props.adm.match(forceRenderMarkupRegex) &&
      props.adm.match(forceRenderMarkupRegex)[1]
  );

  useEffect(() => {
    const forceRenderMarkup = `<div hidden data-str-render-strategy="${forcedRenderStrategy}"></div>\n`;

    let newAdm;
    if (!forcedRenderStrategy) {
      newAdm = props.adm.replace(forceRenderMarkupRegex, '');
    } else if (props.adm.match(forceRenderMarkupRegex)) {
      newAdm = props.adm.replace(
        forceRenderMarkupRegex,
        forceRenderMarkup
      );
    } else {
      newAdm = `${forceRenderMarkup}${props.adm}`;
    }

    props.setAdm(newAdm)
  }, [forcedRenderStrategy]);

  return (
    <Fragment>
      <label htmlFor="adm" className="enhanced-ad_label">
        Drop your JS tag below to preview
      </label>
      <textarea
        value={props.adm}
        onChange={event => props.setAdm(event.target.value)}
        name="adm"
        data-testid="adm-field"
        className="enhanced-ad_form-input"
        id="adm"
        rows="8"
      />
      {props.currentUser.admin && props.adm && <BannerMetadata />}
      {props.currentUser.admin && (
        <section className="mb3">
          <label className="clickable mb1">
            <input
              type="checkbox"
              className="mr1"
              checked={!!forcedRenderStrategy}
              onChange={() => {
                setForcedRenderStrategy(
                  forcedRenderStrategy
                    ? null
                    : Object.keys(RENDERING_STRATEGIES)[0]
                );
              }}
            />
            Force a rendering strategy
          </label>
          {forcedRenderStrategy && (
            <div className="mb2 ml2">
              {Object.keys(RENDERING_STRATEGIES).map(strategy => (
                <div key={strategy}>
                  <label className="clickable mb1">
                    <input
                      className="mr1"
                      type="radio"
                      name="forced-render-strategy"
                      checked={forcedRenderStrategy === strategy}
                      onChange={() => {
                        setForcedRenderStrategy(strategy);
                      }}
                    />
                    {RENDERING_STRATEGIES[strategy].displayedName}
                  </label>
                </div>
              ))}
            </div>
          )}
        </section>
      )}
    </Fragment>
  );
};

AdmField.propTypes = {
  currentUser: PropTypes.shape({ admin: PropTypes.bool }).isRequired,
  adm: PropTypes.string.isRequired,
  setAdm: PropTypes.func.isRequired
};
